<tt-page *ngIf="!!page">
    <ng-container *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>

        <tt-list *ngIf="page.show_last_produced_stockbatches === '1'" [ttData]="itemsListStockBatchLasts"></tt-list>
    </ng-container>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="finishpohscan_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="h_selection_criteria">
                        <ng-container *ngTemplateOutlet="info"></ng-container>
                    </tt-card>

                    <tt-list *ngIf="page.show_last_produced_stockbatches === '1'" class="col-xs-12 p-5" [ttData]="itemsListStockBatchLasts"></tt-list>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="h_functions">
                        <ng-container *ngTemplateOutlet="buttons"></ng-container>
                    </tt-card>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="labour" [ttModel]="page.labour_name" [ttButtons]="labourNameButtons" ttReadonly></tt-input>
        <tt-input *ngIf="page.show_stockplace === '1'" ttLabel="stockplace" [ttModel]="page.stockplace_name" ttReadonly></tt-input>
        <tt-input ttLabel="operation" [ttModel]="page.operation_name" [ttButtons]="operationNameButtons" ttReadonly></tt-input>
        <tt-input *ngIf="page.show_equipment === '1'" ttLabel="equipment" [ttModel]="page.equipment_name" [ttButtons]="equipmentNameButtons" ttReadonly></tt-input>

        <form class="form-horizontal sp-0" name="formFinishPohScan" novalidate (ngSubmit)="searchOrScanProductionOrder()" method="get" role="form" [hidden]="page.show_barcode === '0'">
            <tt-input ttLabel="finishpohscan_search" ttFocus="true" [(ttModel)]="barcode" ttShowClearButton [ttButtons]="barcodeButtons"></tt-input>
        </form>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!page">
        <tt-button-goto *ngIf="page.show_paperless === '1'" [ttText]="'m_powcue'" [ttGoto]="'paperlesspo'"></tt-button-goto>
        <tt-button-goto [ttText]="'po_finishes'" [ttGoto]="'pofinishlist'"></tt-button-goto>
        <tt-button-goto [ttText]="'productionstatus'" [ttGoto]="'productionstatus'"></tt-button-goto>
        <tt-button-settings *ngIf="page.show_setting === '1'"></tt-button-settings>
    </ng-container>
</ng-template>
